/*
  Bothanica Mineral — Animação de pétalas decorativas (PREVEM 80 PDP)

  - Carrega GSAP + ScrollTrigger de forma assíncrona (não bloqueia o LCP).
  - Em cada pétala: reveal (fade/scale) ao entrar na viewport + drift de
    parallax ligado ao scroll (scrub). O float contínuo e leve é feito em CSS.
  - Respeita prefers-reduced-motion: não anima, deixa as pétalas estáticas
    no fallback do CSS.
  - Idempotente: roda uma única vez por página mesmo se incluído várias vezes.
*/
(function () {
  if (window.__bmPetalsInit) return;
  window.__bmPetalsInit = true;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start() {
    var petals = document.querySelectorAll('.bm-petal');
    if (!petals.length) return;

    // Sem movimento: mantém o estado estático do CSS e encerra.
    if (prefersReduced) return;

    loadGsap(function (ok) {
      if (!ok || !window.gsap || !window.ScrollTrigger) return; // fallback CSS
      var gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);

      // Guarda a opacidade-alvo (definida por pétala no CSS) ANTES de zerar,
      // depois esconde para o reveal.
      petals.forEach(function (el) {
        var target = parseFloat(getComputedStyle(el).opacity);
        el.dataset.bmTargetOpacity = isNaN(target) ? '0.5' : String(target);
        gsap.set(el, { autoAlpha: 0, scale: 0.6 });
      });

      // Reveal coordenado das pétalas que entram juntas na viewport.
      window.ScrollTrigger.batch('.bm-petal', {
        start: 'top 92%',
        once: true,
        onEnter: function (batch) {
          gsap.to(batch, {
            autoAlpha: function (i, el) {
              return parseFloat(el.dataset.bmTargetOpacity) || 0.5;
            },
            scale: 1,
            duration: 0.9,
            ease: 'power2.out',
            stagger: 0.12,
            overwrite: 'auto',
          });
        },
      });

      // Parallax: cada pétala deriva no eixo Y conforme a seção rola.
      petals.forEach(function (petal, i) {
        var section =
          petal.closest('[id^="shopify-section-"]') ||
          petal.closest('section') ||
          petal.parentElement;
        if (!section) return;

        // Pétalas alternadas sobem/descem em ritmos diferentes.
        var drift = (i % 2 === 0 ? -1 : 1) * (60 + (i % 3) * 28);

        gsap.fromTo(
          petal,
          { yPercent: -drift / 4 },
          {
            yPercent: drift / 4,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1,
            },
          }
        );
      });

      window.ScrollTrigger.refresh();
    });
  }

  // —— Carregamento assíncrono do GSAP + ScrollTrigger (uma vez) ——
  function loadGsap(cb) {
    if (window.gsap && window.ScrollTrigger) return cb(true);

    var core = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var st =
      'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

    inject(core, function (okCore) {
      if (!okCore) return cb(false);
      inject(st, function (okSt) {
        cb(okSt);
      });
    });
  }

  function inject(src, done) {
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () {
      done(true);
    };
    s.onerror = function () {
      done(false);
    };
    document.head.appendChild(s);
  }

  // Só inicia depois do load para não competir com o LCP/render inicial.
  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
})();
